import React from 'react';
import './homepage.styles.scss';

const HomePage = () => (
    <div className='homepage'>
        <div className= 'name-wrapper'>
       <div className="name-container1">
        <div className='letter' >L</div>
        <div className='letter' >U</div>
        <div className='letter' >K</div>
        <div className='letter' >E</div>
       </div>
       <div className="name-container2">
        <div className='letter' >J</div>
        <div className='letter' >O</div>
        <div className='letter' >H</div>
        <div className='letter' >N</div>
       </div>
       </div>
    </div>
);

export default HomePage;